import "./index.sass";

interface AnimtionLeftPanelBlueProps {
  image: string;
  startAnimation?: boolean;
  style?: React.CSSProperties;
}

const AnimtionLeftPanelBlue = ({ image, startAnimation = false, style = {} }: AnimtionLeftPanelBlueProps) => {
  return (
    <div id={`animation-left-panel-blue`}>
      <img style={style} className={`animation-left-panel-blue-img  ${startAnimation ? "animated" : ""}`} src={image} alt="" />
    </div>
  );
};

export default AnimtionLeftPanelBlue;
